import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { IOffice } from '@shared/interfaces/office.interface';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { bookingsListMock } from 'src/mocks/bookings-fake.mock';
import { ProfileService } from '../../shared/services/profile.service';
import { Router } from '@angular/router';
import { Subject, debounceTime } from 'rxjs';
import { environment } from 'src/environments/environment';


declare var google: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  data: any;

  options: any;
  public serviceData: any[] = [];
  public services: any[] = [];
  public serviceItem: any[] = [];
  public totalSellTurn: number = 0.00;
  public bookingsData!: any[];
  public bookingData: any = [];
  public bookingServicesPlanning: any = [];
  public results: any[] = [];
  public selectedBooking: any = [];
  public office!: IOffice;
  public user: any = [];
  public menuTitle: string = '';
  public allCharts: any = [];
  private chartInstances: any[] = [];
  public cashItems: Array<IToolbarItem> = [
    {
      icon: 'assets/icons/icon_list.png',
      title: 'Ir a listado de hoy',
      titleColor: '#FFFFFF',
      route: '/panel/payments/summary'
    },
    {
      icon: 'assets/icons/icon_cash_closing.png',
      title: this.menuTitle,
      titleColor: '#FFFFFF',
      route: '/panel/payments/cashclose'
    }
  ];


  constructor(
    private router: Router,
    private apiService: ApiService,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef,

  ) { }

  ngOnInit() {
    this.apiService.getServicesList().subscribe((response: any) => {
      this.serviceData = response;
      this.services = this.serviceData.filter((service: any) => service.name);
      this.serviceItem = this.serviceData.map((service: any) => {
        return {
          icon: `assets/svg/${service.icon}.svg`,
          title: service.name,
          titleColor: '#27368A',
          route: `/panel/bookings/add-booking/${service.id}`,
          truncate: true
        }
      })
    });


    this.profileService.getProfile().subscribe(
      (response: any) => {
        this.user = response;

        this.office = this.user.office;
        if (this.office) {

          this.generateTitleCash(this.office.cashier_status);
        }
      }
    );

    this.apiService.get(`/booking-service/lastest/${environment.limitActivitiesOfDashboard}/get`).subscribe(
      (response: any) => {

        if (response.length == 0) {
          this.bookingServicesPlanning = [];
        } else {
          this.bookingServicesPlanning = response;
        }

      }
    );

    this.apiService.getTotalSellTurn().subscribe((response: any) => {

      console.log('response turn: ', response);
      if(response.status == 422){
        this.totalSellTurn = 0.00;
      }else{
        this.totalSellTurn = response || 0;
      }
    });

    this.getBookingCharts();
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.chartInstances.forEach(chart => {
      chart.clearChart();
    });
  }

  getBookingCharts() {
    this.apiService.getBookingCharts().subscribe((charts: any) => {

      this.allCharts = charts;

      google.charts.load('current', { 'packages': ['corechart'] });
      google.charts.setOnLoadCallback(this.drawCharts.bind(this));

    });
  }

  drawCharts() {

    var dataPieAux = this.allCharts.booking_by_offices;
    console.log('allCharts', this.allCharts);
    var dataPieArray = new Array();
    dataPieArray.push(['Reservas', 'Total']);
    dataPieAux.forEach((data: any) => {
      dataPieArray.push([data.name, data.total_reservas]);
    });

    var dataRingAux = this.allCharts.total_bookings_by_status;
    var dataRingArray = new Array();
    dataRingArray.push(['Estatus', 'Total']);
    dataRingAux.forEach((data: any) => {
      dataRingArray.push([data.status, data.total_reservas]);
    });

    var dataColumnsAux = this.allCharts.bookings_by_week;
    var dataColumnsArray = new Array();
    if (dataColumnsAux.length > 0) {
      dataColumnsArray.push(['Dias de semana', 'Total', { role: "style" }]);
      dataColumnsAux.forEach((data: any) => {
        dataColumnsArray.push([data.day_name, data.total_ventas, '#27368a']);
      });
    } else {
      dataColumnsArray.push(['Dias de semana', 'Total']);
      dataColumnsArray.push(['Sin datos', 0]);
    }


    var dataBarsAux = this.allCharts.bookings_by_months;
    var dataBarsArray = new Array();
    if (dataBarsAux.length > 0) {
      dataBarsArray.push(['Meses del año', 'Total', { role: "style" }]);
      dataBarsAux.forEach((data: any) => {
        dataBarsArray.push([`${data.year} - ${data.month_name}`, data.total_ventas, '#27368a']);
      });
    } else {
      dataBarsArray.push(['Mes del año', 'Total']);
      dataBarsArray.push(['Sin datos', 0]);
    }

    var dataColumns2Aux = this.allCharts.incomming_by_week;
    var dataColumns2Array = new Array();
    if (dataColumns2Aux.length > 0) {
      dataColumns2Array.push(['Dias de semana', 'Ingresos', { role: "style" }]);
      dataColumns2Aux.forEach((data: any) => {
        dataColumns2Array.push([data.day_name, data.total, '#27368a']);
      });
    } else {
      dataColumns2Array.push(['Dias de semana', 'Total']);
      dataColumns2Array.push(['Sin datos', 0]);
    }


    var dataBars2Aux = this.allCharts.incomming_by_months;
    var dataBars2Array = new Array();
    if (dataBars2Aux.length > 0) {
      dataBars2Array.push(['Meses del año', 'Ingresos', { role: "style" }]);
      dataBars2Aux.forEach((data: any) => {
        dataBars2Array.push([`${data.year} - ${data.month_name}`, data.total, '#27368a']);
      });
    } else {
      dataBars2Array.push(['Meses del año', 'Total']);
      dataBars2Array.push(['Sin datos', 0]);
    }

    var dataPie = google.visualization.arrayToDataTable(dataPieArray);
    var dataRing = google.visualization.arrayToDataTable(dataRingArray);
    var dataColumns = google.visualization.arrayToDataTable(dataColumnsArray);
    var dataBars = google.visualization.arrayToDataTable(dataBarsArray);
    var dataColumns2 = google.visualization.arrayToDataTable(dataColumns2Array);
    var dataBars2 = google.visualization.arrayToDataTable(dataBars2Array);

    // Set chart options
    var optionsPie = {
      'title': 'Cantidad de reservas por oficina',
      'is3D': true
    };

    var optionsRing = {
      title: 'Cantidad de reservas por estado de este mes',
      // legend: {
      //   alignment: 'center',
      // },
      pieHole: 0.4,
    };

    var optionsColumns = {
      'title': 'Cantidad de reservas de la última semana'
    };
    var optionsBars = {
      'title': 'Cantidad de reservas de los últimos 6 meses'
    };
    var optionsColumns2 = {
      'title': 'Total ingresos de la última semana'
    };
    var optionsBars2 = {
      'title': 'Total ingresos de los últimos 6 meses'
    };

    // Instantiate and draw our charts, passing in some options.
    var chartPie = new google.visualization.PieChart(document.getElementById('chart_pie'));
    var chartRing = new google.visualization.PieChart(document.getElementById('chart_ring'));
    var chartColumns = new google.visualization.ColumnChart(document.getElementById('chart_columns'));
    var chartBars = new google.visualization.BarChart(document.getElementById('chart_bars'));
    var chartColumns2 = new google.visualization.ColumnChart(document.getElementById('chart_columns2'));
    var chartBars2 = new google.visualization.BarChart(document.getElementById('chart_bars2'));

    chartPie.draw(dataPie, optionsPie);
    chartRing.draw(dataRing, optionsRing);
    chartColumns.draw(dataColumns, optionsColumns);
    chartBars.draw(dataBars, optionsBars);
    chartColumns2.draw(dataColumns2, optionsColumns2);
    chartBars2.draw(dataBars2, optionsBars2);

    this.chartInstances.push(
      chartPie,
      chartRing,
      chartColumns,
      chartBars,
      chartColumns2,
      chartBars2
    );
  }

  validatePermission(permissionString: string) {
    let existPermission = this.user?.permissions?.find((permission: any) => {
      return permission.name == permissionString;
    });

    if (existPermission) {
      return true;
    } else {
      return false;
    }
  }

  generateTitleCash(cashier_status: number) {
    this.menuTitle = cashier_status === 0 ? 'Ir a abrir caja' : 'Ir a cierre de caja';
    this.cashItems[1].title = this.menuTitle;
  }

  filterBookingsToday() {
    // const today = new Date();
    // this.bookingsPlanning = this.bookingsData.filter((booking: any) => {
    //   const bookingDate = new Date(booking.date);

    //   return (
    //     bookingDate.getFullYear() === today.getFullYear() &&
    //     bookingDate.getMonth() === today.getMonth() &&
    //     bookingDate.getDate() === today.getDate()
    //   );
    // });
    // this.bookingsPlanning.slice(0, 5);

  }

  navigateToAddBooking(serviceId: number) {
    this.router.navigate(['/panel/bookings/add-booking', { id: serviceId }]);
  }

  search(event: any) {
    const query = event.query;
    if (this.bookingsData && this.bookingsData.length > 0) {
      this.results = this.bookingsData.filter((booking: {
        reference: string;
        vat: string;
        service: string
      }) =>
        booking && booking?.reference.toLowerCase().includes(query.toLowerCase()) ||
        booking && booking?.vat.toLowerCase().includes(query.toLowerCase()) ||
        booking && booking?.service.toLowerCase().includes(query.toLowerCase())

      );
    } else {
      console.error('Error: bookingata no está inicializado o es un arreglo vacío.');
      this.results = [];
    }
  }

  onSelect(event: any) {
    this.selectedBooking = event.value;
    console.log(this.selectedBooking);
    const selectedBookinId = this.selectedBooking.id
    this.router.navigate([`/panel/bookings/modify/${selectedBookinId}`]);


  }

}
